module.exports = __webpack_public_path__ + "img/valuta_invoiceweb.410da07e.png";